import { BACKEND_API_HOST } from '@/app/config';
import { BreadcrumbPoint } from './breadcrumbBuffer';

interface SendOptions {
  keepalive?: boolean;
}

export default async function sendLocationBreadcrumbs(
  meetingHash: string,
  points: BreadcrumbPoint[],
  { keepalive = false }: SendOptions = {},
): Promise<boolean> {
  try {
    const response = await fetch(
      `${BACKEND_API_HOST}/api/schedule/video-meeting/${meetingHash}/location-breadcrumbs/`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ points, client_version: __APP_RELEASE__ }),
        keepalive,
      },
    );
    return response.ok;
  } catch {
    return false;
  }
}
